import cx from "clsx";
import { User } from "kreate-common/modules/business-types";
import Divider from "kreate-common/modules/kreate-ui/components/Divider";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import Link from "next/link";
import * as React from "react";

import SectionSocialLinks from "./containers/SectionSocialLinks";
import styles from "./index.module.scss";

import { EM_DASH } from "@/modules/common-utils/unicode";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  user: User | null | undefined;
};

export default function TabAbout({ className, style, user }: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <Flex.Row justifyContent="space-between" gap="62px" flexWrap="wrap">
        <Flex.Col flex="6 6 600px" gap="24px">
          <div className={styles.subTitle}>{"Biography"}</div>
          <div className={styles.description}>
            {user?.aboutDescription ?? EM_DASH}
          </div>
          <div className={styles.subTitle}>{"Tags"}</div>
          <Flex.Row gap="4px 12px" flexWrap="wrap">
            {user?.tags?.map((tag, index) => (
              <Link
                key={index}
                href={{
                  pathname: "/explore/artists",
                  query: { q: "#" + tag },
                }}
                title={"#" + tag}
                className={styles.tag}
              >
                {"#" + tag}
              </Link>
            ))}
          </Flex.Row>
        </Flex.Col>
        <Flex.Col
          padding="48px"
          className={styles.cardStats}
          flex="1 1 300px"
          gap="24px"
        >
          <Flex.Row alignItems="center" gap="27px">
            <span className={styles.num}>
              {user == null ? EM_DASH : user.numTotalArtworks}
            </span>
            <span className={styles.label}>{"Artworks"}</span>
          </Flex.Row>
          <Flex.Row alignItems="center" gap="27px">
            <span className={styles.num}>
              {user == null ? EM_DASH : user?.lovedBy.length}
            </span>
            <span className={styles.label}>{"Loves"}</span>
          </Flex.Row>
          {/**TODO: add number of people following */}
          <Divider.Horizontal style={{ marginTop: "12px" }} />
          <div className={styles.subTitle} style={{ marginTop: "24px" }}>
            Social
          </div>
          <SectionSocialLinks user={user} key={user?.userId} />
        </Flex.Col>
      </Flex.Row>
    </div>
  );
}
